import { Routes } from '@angular/router';
import { LiveTrackerComponent } from '../pages/live-tracker/live-tracker.component';

const footballLiveTrackerImport = import(
  '@/app/pages/sports/football-livetracker/livetracker.component'
);

export const trackerRoutes: Routes = [
  {
    path: 'matchtracker-live/:sport/:id',
    component: LiveTrackerComponent,
  },

  {
    path: 'livetracker',
    loadComponent() {
      return footballLiveTrackerImport;
    },
  },
];
